import { CustomerUser } from '../../types/customerAuth';
import {
  AuthTokenBundle,
  clearAuthTokenBundle,
  getAccessToken,
  saveAuthTokenBundle,
} from './authTokens';

const CUSTOMER_AUTH_TOKEN_KEY = 'shiftwagon_customer_auth_token';
const CUSTOMER_AUTH_USER_KEY = 'shiftwagon_customer_auth_user';

export function saveCustomerAuthToken(token: string): void {
  saveAuthTokenBundle('customer', { accessToken: token });
}

export function getCustomerAuthToken(): string | null {
  return getAccessToken('customer');
}

export function saveCustomerAuthTokens(bundle: AuthTokenBundle): void {
  saveAuthTokenBundle('customer', bundle);
}

export function clearCustomerAuthToken(): void {
  clearAuthTokenBundle('customer');
  sessionStorage.removeItem(CUSTOMER_AUTH_TOKEN_KEY);
}

export function saveCustomerAuthUser(user: CustomerUser): void {
  sessionStorage.setItem(CUSTOMER_AUTH_USER_KEY, JSON.stringify(user));
}

export function getCustomerAuthUser(): CustomerUser | null {
  const raw = sessionStorage.getItem(CUSTOMER_AUTH_USER_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as CustomerUser;
  } catch {
    return null;
  }
}

export function clearCustomerAuthUser(): void {
  sessionStorage.removeItem(CUSTOMER_AUTH_USER_KEY);
}

export function clearCustomerAuthFlow(): void {
  clearCustomerAuthToken();
  clearCustomerAuthUser();
}
